/* global BigInt */
import { validCategoryRates } from '../../services/categoryPricing';
import { moneyMinor } from '../../utils/money';

export const validRetailPricing = (pricing) =>
  pricing?.available === true &&
  pricing.currency === 'USD' &&
  Number.isSafeInteger(pricing.revision) &&
  pricing.revision >= 0 &&
  (pricing.pricingBasis === 'piece'
    ? validCategoryRates(pricing.categoryRates, { allowZero: true }) &&
      pricing.categoryRates.length > 0
    : (pricing.pricingBasis === undefined || pricing.pricingBasis === 'unit') &&
      typeof pricing.ratePerUnit === 'number' &&
      Number.isFinite(pricing.ratePerUnit) &&
      pricing.ratePerUnit >= 0 &&
      /^\d+(?:\.\d{1,4})?$/.test(String(pricing.ratePerUnit)) &&
      Number.isSafeInteger(Math.round(pricing.ratePerUnit * 10000)));

export function retailPieceDraftAmount(lines, products, pricing) {
  if (pricing?.pricingBasis !== 'piece' || !validRetailPricing(pricing) || !lines.length)
    return null;
  let total = 0n;
  for (const line of lines) {
    const quantity = Number(line.quantity);
    const product = products?.find((row) => row._id === line.product);
    const rate = pricing.categoryRates.find((row) => row.familyKey === product?.familyKey);
    if (!rate || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 1000) return null;
    total += BigInt(quantity) * BigInt(rate.pricePerPieceCents);
  }
  return total <= BigInt(Number.MAX_SAFE_INTEGER) ? moneyMinor(Number(total)) : null;
}

export const validRetailPieceSale = (sale) =>
  sale?.schemaVersion === 2 &&
  sale.pricingBasis === 'piece' &&
  sale.currency === 'USD' &&
  Number.isSafeInteger(sale.revision) &&
  sale.revision >= 0 &&
  Number.isSafeInteger(sale.customerPricingRevision) &&
  sale.customerPricingRevision >= 0 &&
  validCategoryRates(sale.categoryRates, { allowZero: true }) &&
  moneyMinor(sale.productSubtotalMinor) !== null &&
  Array.isArray(sale.lines) &&
  sale.lines.length > 0 &&
  sale.lines.length <= 20 &&
  sale.lines.every((line) => {
    const rate = sale.categoryRates.find((row) => row.familyKey === line?.familyKey);
    return (
      rate &&
      typeof line.product === 'string' &&
      line.product.length > 0 &&
      typeof line.size === 'string' &&
      line.size.length > 0 &&
      Number.isSafeInteger(line.quantity) &&
      line.quantity > 0 &&
      line.quantity <= 1000 &&
      Number.isSafeInteger(line.units) &&
      line.units > 0 &&
      line.pricePerPieceCents === rate.pricePerPieceCents &&
      moneyMinor(line.amountMinor) !== null &&
      BigInt(line.amountMinor) === BigInt(line.quantity) * BigInt(rate.pricePerPieceCents)
    );
  }) &&
  sale.lines.reduce((sum, line) => sum + BigInt(line.amountMinor), 0n) ===
    BigInt(sale.productSubtotalMinor);
